export default class SendReeditionFactureModel {
    public id = 0
    public mail = ''
    public corps = ''
    public files = [] as Blob[]
}
